// 分页 组件 pages

// import pages from './pages';
import ReHeader from '../../../basic/re_header';
import ReFooter from '../../../basic/re_footer';
export default {
  name: 'pageNews',
  props: {
    list: Array,
    hasHeader: {
      default: true,
      type: Boolean
    },
    hasFooter: {
      default: true,
      type: Boolean
    }
  },
  data: function data() {
    return {
      newsList: [
      //     {
      //         url:
      // '//www.iwf.org.uk/news/liveme-joins-iwf-to-he…RMyZEQvow23AgggLnMiP%2BoMsczIh%2FQGFLMDBUaQ%3D%3D',
      //         date: '2019-11-18',
      //         title: 'LiveMe joins IWF to help improve protection for users'
      //     },
      //     {
      //         url:
      // '//finance.yahoo.com/news/livemes-online-safety-measures-prove-185300505.html',
      //         date: '2018-11-28',
      //         title:
      // "LiveMe's New Online Safety Measures Prove Successf…owing Social Media Moderation Challenges Globally"
      //     },
      //     {
      //         url:
      // 'http://www.fox14tv.com/story/39522752/liveme-found…t-the-2018-womens-entrepreneurship-day-wed-summit',
      //         date: '2018-11-21',
      //         title:
      // "LiveMe Founder Yuki He Asks Young Women to Make 'U…he 2018 Women's Entrepreneurship Day (WED) Summit"
      //     },
      // 2022-04-10 新增 新闻
      {
        url: '/static-page/news/InterviewwithImanAbdelaal.html',
        date: '2022-04-10',
        title: 'How LiveMe Empowers 80m Live Streaming Creators: Q/A with Head of Operations Iman Abdelaal'
      },
      // 2022 01 27 新增 新闻
      {
        url: '/static-page/news/goldenaward.html',
        date: '2022-01-20',
        title: 'LiveMe won the 2021 "Golden Award" for the Most Growth Innovative Company of the Year'
      }, {
        url: '/static-page/news/gtc.html',
        date: '2022-01-20',
        title: 'LiveMe won the "Best Entertainment App most loved by overseas users", and its overseas achievements have been widely recognized'
      }, {
        url: '/static-page/news/samsungappstore.html',
        date: '2022-01-20',
        title: 'Won the Best Pan-entertainment App Award from Samsung App Store, LiveMe continues to lead the development of the overseas live broadcast industry'
      }, {
        url: '/static-page/news/mostinnovativefounder.html',
        date: '2022-01-20',
        title: 'LiveMe founder Yuki He was awarded the title of "Most Innovative Founder", demonstrating the charm of female founders'
      }, {
        url: '//www.eastwestbank.com/ReachFurther/en/News/Article/Why-Consumers-Love-Watching-Livestreams',
        date: '2018-11-01',
        title: 'Raw, Uncut and Uncensored: Why Consumers Love Watching Livestreams'
      },
      //     {
      //         url:
      // '//finance.yahoo.com/news/liveme-launches-social-good-initiative-150000585.html',
      //         date: '2018-10-12',
      //         title:
      // 'LiveMe Launches Social Good Initiative To Raise Awareness And Funding For Charitable Causes'
      //     },
      {
        url: '//www.theguardian.com/money/2017/oct/07/millennials-making-a-living-from-livestreaming',
        date: '2018-10-07',
        title: 'Meet the millennials who are making a living from livestreaming'
      }, {
        url: '//www.elitedaily.com/p/michelle-osorio-andy-…-engaged-despite-5000-miles-between-them-11878598',
        date: '2018-09-13',
        title: 'Michelle Osorio & Andy Martin Met On LiveMe & Got Engaged Despite 5,000 Miles Between Them'
      }, {
        url: '//variety.com/2018/digital/asia/musically-shutdown-tiktok-bytedance-1202893205/',
        date: '2018-08-02',
        title: 'Musical.ly Is Going Away: Users to Be Shifted to Bytedance’s TikTok Video App'
      }, {
        url: '//www.fiercevideo.com/video/liveme-absorbs-fellow-live-streaming-app-live-ly',
        date: '2018-07-23',
        title: 'LiveMe absorbs fellow livestreaming app Live.ly'
      }, {
        url: '//www.tubefilter.com/2018/07/23/musically-lively-bytedance-liveme/',
        date: '2018-07-23',
        title: 'Musical.ly Reportedly Shut Down Live.ly Because Its Owner Didn’t Want A LiveMe Competitor'
      }, {
        url: 'http://www.streamingmedia.com/Articles/ReadArticle.aspx?ArticleID=126455',
        date: '2018-07-23',
        title: 'Musical.ly’s shutdown of Live.ly was contractually obligated'
      }, {
        url: 'http://www.streamingmedia.com/Articles/ReadArticle.aspx?ArticleID=126455',
        date: '2018-07-23',
        title: 'Musical.ly Now Directs Former Live.ly Members to LiveMe App'
      }, {
        url: 'https://www.tubefilter.com/2018/07/23/musically-lively-bytedance-liveme/',
        date: '2018-07-23',
        title: "Musical.ly Reportedly Shut Down Live.ly Because Its Owner Didn\u2019t Want A LiveMe Competitor"
      }, {
        url: 'https://gadgets.ndtv.com/games/news/fluxr-mobile-game-streaming-app-launched-with-support-for-pubg-mobile-tournaments-1881052',
        date: '2018-07-10',
        title: 'Fluxr Mobile Game Streaming App Launched With Support for PUBG Mobile Tournaments'
      }, {
        url: 'https://www.abacusnews.com/esports/playerunknowns-battlegrounds-hopes-find-new-audience-mobile-streaming/article/2154085',
        date: '2018-07-06',
        title: "PlayerUnknown\u2019s Battlegrounds hopes to find a new audience with mobile streaming"
      }, {
        url: 'https://www.pocketgamer.biz/news/68521/livemes-new-streaming-app-fluxr-will-promote-playerunknowns-battlegrounds-esports/',
        date: '2018-07-06',
        title: "LiveMe\u2019s new streaming app Fluxr will promote Playerunknown\u2019s Battlegrounds esports"
      }]
    };
  },
  methods: {},
  components: {
    'website-header': ReHeader,
    'website-footer': ReFooter
  },
  mounted: function mounted() {}
};